import React from "react";
import Button from "./Button/Button";
const ResetFilters = ({ id, onClick, }) => (React.createElement(Button, { variant: "text", isInline: true, id: id, onClick: onClick }, "Reset filters"));
export default ResetFilters;
//# sourceMappingURL=ResetFilters.js.map